module.exports = __webpack_public_path__ + "fonts/16d7bb99c6f81cacdd91cd92d8ddb545-Roboto-Bold.ttf";